// Sample blog post data (fallback when database is empty)
export const samplePosts = [
  {
    id: 'sample-1',
    title: 'James Fauntleroy: The Invisible Architect of Modern R&B',
    content: `
      <p>In an industry obsessed with celebrity, James Fauntleroy has mastered the art of being everywhere and nowhere at once. His pen has touched some of the most iconic songs of the 21st century, yet he remains a mystery to most music fans.</p>
      
      <h3>The Songwriter's Songwriter</h3>
      
      <p>With credits including Beyoncé's "Drunk in Love," Frank Ocean's "Lost," and Justin Timberlake's "Suit & Tie," Fauntleroy has become the go-to collaborator for artists seeking emotional depth and sonic innovation. His ability to channel vulnerability into verse has made him indispensable in an era where authenticity is currency.</p>
      
      <p>What sets Fauntleroy apart isn't just his melodic sensibility—it's his understanding of space. He knows when to fill a song with words and when to let silence speak. This restraint, this patience, is what makes his work timeless.</p>
      
      <h3>The Aesthetic Form</h3>
      
      <p>Fauntleroy's approach to songwriting mirrors his approach to life: intentional obscurity. While his peers chase spotlight and streams, he's content to let the work speak for itself. In doing so, he's created something rare in modern music—a legacy built on craft rather than celebrity.</p>
    `,
    featured_image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80',
    created_at: new Date().toISOString(),
    post_type: 'article'
  }
];
